mutation DeleteBarMitzvah($username: String!) {
  deleteBarMitzvah(username: $username) {
    ok
    errors
  }
}
